import React, { useState, useEffect } from "react";
import withLanguageContext from "lib/hocs/withLanguageContext";
import BaseGrid from "Components/Fragment/BaseGrid";
import config from "lib/config";
import format from "lib/format";
import * as CONSTANTS from "domains/programs/constants";
import * as MainMenu from "lib/constants/mainmenu";
import ProgramItem from "../Item/Program";
import { useMyLearning } from "../../context";
import { filterBtPrograms } from "../../functions";

const isPortalOverview =
  window.location &&
  window.location.pathname.includes("/activitycentre/activitycentre.aspx");

const ProgramItems = ({ languageContext, onClick, managerView }) => {
  const {
    filteredPrograms,
    personalId,
    isBt,
    listView,
    viewLimit,
    viewLimitNr,
  } = useMyLearning();
  const [currentPrograms, setCurrentPrograms] = useState([]);

  const updateRating = (newRating, newComment, programId) => {
    const updatedPrograms = currentPrograms.map((pr) => {
      if (pr.courseId === programId) {
        return {
          ...pr,
          personalRating: {
            ...pr.personalRating,
            comment: newComment,
            rating: newRating,
          },
        };
      }
      return pr;
    });
    setCurrentPrograms(updatedPrograms);
  };

  useEffect(() => {
    setCurrentPrograms(filterBtPrograms(filteredPrograms.active, isBt));
  }, [filteredPrograms]);

  const items = Array.isArray(currentPrograms)
    ? currentPrograms.map((program) => {
        let programUrl = `${config.urlRoot}#/edu/program?activityId=${program.activityId}`;
        programUrl = personalId ? `${programUrl}&id=${personalId}` : programUrl;
        programUrl = isPortalOverview
          ? programUrl
          : `${programUrl}&prev=${MainMenu.ID_COWORKER_MYCOURSES}`;

        const defaultImageUrl = isPortalOverview
          ? format.url(CONSTANTS.PROGRAM_IMAGE_PORTALOVERVIEW)
          : format.url(CONSTANTS.PROGRAM_IMAGE);

        const imageUrl = program.image
          ? format.url(
              `/utils/streamfile.aspx?type=courseobjectimage&param=${program.courseId}/${program.image}`,
            )
          : defaultImageUrl;

        return {
          title: program.title,
          item: (
            <ProgramItem
              program={{ ...program, imageUrl }}
              programUrl={programUrl}
              managerView={managerView}
              languageContext={languageContext}
              onClick={onClick}
              updateRating={updateRating}
              imageUrl={imageUrl}
            />
          ),
        };
      })
    : [];

  const programItems =
    viewLimit && items.length > viewLimitNr
      ? items.slice(0, viewLimitNr)
      : items;

  return (
    <BaseGrid
      id="learningActivitiesMyLearningList"
      spacing={1}
      justifyContent="flex-start"
      direction={listView ? "column" : "row"}
      childWidth="auto"
    >
      {programItems?.map(({ item, title }, index) => (
        <div key={title + index}>{item}</div>
      ))}
    </BaseGrid>
  );
};

export default withLanguageContext(ProgramItems, "Programs");
